
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './components/Home';
import AccessibilityStatement from './components/AccessibilityStatement';


function App() {
  return (
    <div className="App">
      <BrowserRouter>

        <Routes>


          <Route path='/' element={<Home />} />



          <Route path='/AccessibilityStatement' element={<AccessibilityStatement />} />


        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
